import React from "react";
import { Link } from "react-router-dom";

function WidgetImage({ product }) {
    const imageUrl = Array.isArray(product.images) && product.images.length
        ? product.images[0]
        : "/images/products/no_img.jpg";

    return (
        <div className="widget-products__image">
            <Link to={`/shop/product/${product.id}`}>
                <img src={imageUrl} alt={product.name} />
            </Link>
        </div>
    );
}

export default WidgetImage ;